import { IFormViewForm } from 'components/FormView';

const CustomerProductDetail: { [x: string]: IFormViewForm } = {
  CustomerProductDetail: {
    id: 'CustomerProductDetail',
    layout: {
      rows: 1,
      columns: 2,
    },
    fields: [
      {
        id: '1',
        type: 'PAPER_CONTAINER',
        visible: true,
        props: {
          name: 'activity',
          fullWidth: true,
          elevation: 0
        },
        position: {
          row: 1,
          col: 1
        },
        children: [
          {
            id: 1,
            type: 'TEXT_FIELD',
            props: {
              label: 'Customer product',
              name: 'CustomerProdCode',
              size: 'medium',
              disabled: true
            },
          },
          {
            id: 2,
            type: 'TEXT_FIELD',
            props: {
              label: 'Description',
              name: 'CustomerProdDescription',
              size: 'medium',

            },
          },
          {
            id: 3,
            type: 'TEXT_AREA',
            props: {
              label: 'Comment',
              name: 'CustomerProdComment',
              fullWidth: true,
              style: {
                height: 150
              }
            },
          }
        ]
      }
    ]
  }
};

export default CustomerProductDetail;
